import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postCompany,
  putCompany,
  softDeleteCompany,
  putDefaultFarm,
  postClientCompany,
  putClientCompany,
  softDeleteClientCompany
} from '@galo-monitor/services/apis/galoMonitorApi/resources/company'

import { CompanyActions, CompanyTypes } from './duckCompany'

function* saveCompany({ company, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(company.id ? putCompany : postCompany , company)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyActions.companyError(err.message))
    yield call(onError, err)
  }
}

function* removeCompany({ company, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(softDeleteCompany, company)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyActions.companyError(err.message))
    yield call(onError, err)
  }
}

function* setDefaultFarm({ farmId, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(putDefaultFarm, { farmId })
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyActions.companyError(err.message))
    yield call(onError, err)
  }
}

function* saveClientCompany({ clientCompany, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(clientCompany.id ? putClientCompany : postClientCompany , clientCompany)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyActions.companyError(err.message))
    yield call(onError, err)
  }
}

function* removeClientCompany({ clientCompany, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(softDeleteClientCompany, clientCompany)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyActions.companyError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(CompanyTypes.SAVE_COMPANY, saveCompany),
  takeLatest(CompanyTypes.REMOVE_COMPANY, removeCompany),
  takeLatest(CompanyTypes.SAVE_CLIENT_COMPANY, saveClientCompany),
  takeLatest(CompanyTypes.REMOVE_CLIENT_COMPANY, removeClientCompany),
  takeLatest(CompanyTypes.SET_DEFAULT_FARM, setDefaultFarm)
]
